import React from 'react'
import { motion } from 'framer-motion'

const About: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6 px-4">
            About Body Science Rehab
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto px-4">
            Leading the future of physiotherapy with innovation and compassion
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center mb-12 sm:mb-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-4 sm:space-y-6"
          >
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">Our mission</h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              At Body Science Rehab, we’re revolutionizing physiotherapy through proper diagnosis, advance assessment scales, personalized treatment plans and comprehensive rehabilitation programs. Our mission is to help every patient achieve optimal recovery and maintain long-term wellness.
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              We combine advance treatment methods with compassionate care to deliver results that exceed expectations. Our evidence-based approach ensures that every treatment is tailored to your unique needs and goals.
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img
              src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
              alt="PhysioCare Clinic"
              className="rounded-2xl shadow-2xl"
            />
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="card p-5 sm:p-6 lg:p-8"
          >
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-3 sm:mb-4">Our vision</h3>
            <p className="text-gray-600 dark:text-gray-300">
              To be the leading provider of advanced physiotherapy services, setting new standards in patient care and recovery outcomes.
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="card p-5 sm:p-6 lg:p-8"
          >
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-3 sm:mb-4">Our values</h3>
            <p className="text-gray-600 dark:text-gray-300">
            Excellence, Innovation, Compassion and Integrity guide everything we do in delivering exceptional patient care.
            </p>
          </motion.div>
        </div>

        {/* Our values - separated for balanced layout */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="card p-5 sm:p-6 lg:p-8 mb-12 sm:mb-16 max-w-4xl mx-auto text-center"
        >
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-3 sm:mb-4">Our commitment</h3>
          <p className="text-gray-600 dark:text-gray-300">
          Your Stability Our Responsibility
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-6 sm:mb-8 px-4">
            Our specialties
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {[
              'Neurological Rehabilitaion',
              'Orthopedic conditions rehabiloitation',
              'Sports injury rehabilitation',
              'Pediatric physiotherapy',
              'Geriatric physiotherapy',
              'Cardio-respiratory rehabilitation',
              'Women’s health',
              'Lifestyle modifications',
              'Diet and Nutrition Advice'
            ].map((specialty, index) => (
              <motion.div
                key={specialty}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="card p-4 sm:p-5 lg:p-6 text-center"
              >
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white">
                  {specialty}
                </h3>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Doctor profile moved to Team page */}
      </div>
    </div>
  )
}

export default About
